
<div class="card">
  <div class="card-header">
    <div class="d-flex justify-content-between align-items-center">
      <div class="card-title">
        Auth Logs
      </div>

      <button
        type="button"
        title="Refresh Logs"
        class="btn btn-primary btn-round"
        (click)="refresh()"
        data-testid="auth-logs-refresh-logs">
        <i class="fa-solid fa-rotate-right"></i>
      </button>
    </div>
  </div>

  <div class="card-body p-0">
    <div class="filter">
      <div class="title mr-5">Filter: </div>

      <div class="date-filter">
        <div class="d-flex align-items-center">
          <label for="start-date" class="nowrap mr-2 mb-0 p-0">Start </label>
          <input
            [(ngModel)]="filter.startDate"
            type="date"
            id="start-date"
            class="form-control"
            (change)="filterByDate()"
            data-testid="auth-logs-start-date">
        </div>

        <div class="d-flex align-items-center">
          <label for="end-date" class="nowrap mr-2 mb-0 p-0">End </label>
          <input
            [(ngModel)]="filter.endDate"
            type="date"
            id="end-date"
            class="form-control"
            (change)="filterByDate()"
            data-testid="auth-logs-end-date">
        </div>

        <div class="d-flex align-items-center">
          <label for="text-filter" class="nowrap mr-2 mb-0 p-0">Search </label>
          <input
            [(ngModel)]="filter.searchText"
            type="text"
            id="text-filter"
            class="form-control"
            data-testid="auth-logs-search-text">
        </div>

        <button
          type="button"
          class="btn btn-primary"
          (click)="getAuthLogs()"
          data-testid="auth-logs-search">
          <i class="fa fa-search mr-1"></i>
          Search
        </button>

        <div class="d-flex align-items-center">
          <input
            [(ngModel)]="filter.errorsOnly"
            id="errors-only"
            type="checkbox"
            (change)="filterByErrorsOnly()"
            class="mx-1 my-1"
            data-testid="auth-logs-errors-only-checkbox">
          <label for="errors-only" class="mx-1 my-1">Errors Only</label>
        </div>
      </div>


      <button *ngIf="filter.logTypeId" class="btn btn-secondary py-1" (click)="removeTypeFilter()" data-testid="auth-logs-remove-type-filter">
        Type: {{ filter.logTypeName }}
        <i class="fa fa-times"></i>
      </button>

      <button
        *ngIf="filter.userId"
        class="btn btn-secondary py-1"
        (click)="removeUserFilter()"
        data-testid="auth-logs-remove-user-filter">
        User: {{ filter.userName }}
        <i class="fa-solid fa-times"></i>
      </button>

      <div class="flex-spacer"></div>

      <button *ngIf="hasFilters" class="btn btn-secondary py-1" (click)="clearFilters()" data-testid="auth-logs-clear">
        Clear
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <ngx-datatable
      *ngIf="!rerenderTable"
      #table
      class="material striped auth-table-height"
      [rows]="authLogs"
      [loadingIndicator]="isLoading"
      [headerHeight]="40"
      [footerHeight]="40"
      [rowHeight]="45"
      [scrollbarV]="true"
      [columnMode]="columnMode.force"
      [sorts]="[{prop: 'timestamp', dir: 'desc'}]"
    >
      <!-- Timestamp -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Timestamp"
        prop="timestamp"
        [resizeable]="false"
        [sortable]="true"
        [width]="200"
        [maxWidth]="200"
      >
        <ng-template ngx-datatable-cell-template let-timestamp="value">
          <div>{{getTimestampString(timestamp)}}</div>
        </ng-template>
      </ngx-datatable-column>

      <!-- Is Success -->
      <ngx-datatable-column
        cellClass="text-center"
        headerClass="text-center"
        name="Success"
        prop="success"
        [sortable]="true"
        [width]="100"
        [maxWidth]="100"
      >
        <ng-template ngx-datatable-cell-template let-success="value">
          <i *ngIf="success" class="fa fa-check text-success"></i>
          <i *ngIf="!success" class="fa fa-xmark text-danger"></i>
        </ng-template>
      </ngx-datatable-column>

      <!-- Log Type -->
      <ngx-datatable-column
        cellClass="text-left"
        headerClass="text-left"
        name="LogType"
        prop="logType"
        [sortable]="true"
        [width]="100"
        [maxWidth]="150"
      >
        <ng-template ngx-datatable-cell-template let-row="row" let-logType="value" let-rowIndex="rowIndex">
          <div class="d-flex align-items-center">
            <div
              class="filterable"
              (click)="filterByLogType(row)"
              [attr.data-testid]="'auth-logs-filter-by-log-type-' + rowIndex">
              {{logType}}
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>



      <!-- User -->
      <ngx-datatable-column
        headerClass="text-center"
        cellClass="text-right"
        name="User"
        prop="userName"
        [sortable]="true"
        [width]="250"
        [maxWidth]="300"
      >
        <ng-template ngx-datatable-cell-template let-userName="value" let-row="row" let-rowIndex="rowIndex">
          <div class="user-name w-100">
            <div
              [title]="userName"
              class="filterable"
              role="button"
              (click)="filterByUser(row)"
              aria-label="User"
              [attr.data-testid]="'auth-logs-user-' + rowIndex">
              {{ userName }}
            </div>

            <div
              *ngIf="row.userId"
              title="Copy User ID to clipboard"
              role="button"
              class="copy-to-clipboard fa-regular fa-clipboard"
              (click)="copyToClipboard(row)"
              [attr.data-testid]="'auth-logs-copy-user-id-to-' + rowIndex">
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>



       <!-- Detail -->
      <ngx-datatable-column
        cellClass="text-left flex-grow-1"
        headerClass="text-center flex-grow-1"
        name="Detail"
        prop="detail"
        [resizeable]="true"
        [width]="250"
        [maxWidth]="undefined"
      >
        <ng-template ngx-datatable-cell-template let-detail="value">
          <div class="">{{detail}}</div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>

</div>





// WEBPACK FOOTER //
// ./src/app/developer/logs/auth-logs/auth-logs.component.html